import { Avatar, Box, Button, Stack, SvgIcon, Typography } from '@mui/material';
import { Loader } from 'Components';
import { useIsDesktop } from 'Hooks';
import { PurpleOutlineWarningIcon } from 'Images';
import { ReactComponent as PurpleDownloadIcon } from 'Images/General/PurpleDownloadIcon.svg';
import { useState } from 'react';

interface IActivityItem {
  activity: {
    id: number;
    label: string;
    onClick?: () => void;
    showIcon?: boolean;
    searchWords: string[];
  };
}

export const ActivityItem = ({ activity }: IActivityItem) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const isDesktop = useIsDesktop();

  const onClick = async () => {
    if (activity.onClick) {
      if (!activity.showIcon) {
        window.scrollTo(0, 0);
      } else setIsLoading(true);

      try {
        await activity.onClick();
      } catch (err) {
        setIsDisabled(true);
        setErrorMessage((err as Error).message);
      }
      setIsLoading(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <Button
        key={activity.label}
        onClick={onClick}
        disabled={isDisabled}
        sx={{
          p: isDesktop ? '16px' : '12px',
          border: '1px solid',
          borderColor: 'purple2.shade_300',
          borderRadius: '12px',
          width: isDesktop ? '179px' : '155px',
          height: '100%',
          bgcolor: isDesktop ? undefined : 'white',
          justifyContent: 'space-between',
          ':disabled': {
            color: 'inherit',
            bgcolor: 'primary.shade_100',
            borderColor: 'primary.shade_200',
            '& path': { stroke: '#B7CCFF' },
          },
        }}
      >
        <Typography
          color={'initial'}
          variant={isDesktop ? 'body3' : 'body5'}
          textAlign={'left'}
          width={activity.showIcon ? '110px' : undefined}
        >
          {activity.label}
        </Typography>
        {activity.showIcon &&
          (isLoading ? (
            <Box
              position={'relative'}
              sx={{
                top: '0',
                height: '24px ',
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Loader size={16} />
            </Box>
          ) : (
            <SvgIcon component={PurpleDownloadIcon} />
          ))}
      </Button>
      {isDisabled && (
        <Stack
          flexDirection={'row'}
          gap={'8px'}
          maxWidth={isDesktop ? '179px' : '155px'}
        >
          <Avatar
            src={PurpleOutlineWarningIcon}
            alt=''
            sx={{ width: '15px', height: '15px' }}
          />
          <Typography variant={'body7'}>{errorMessage}</Typography>
        </Stack>
      )}
    </Box>
  );
};
